module.exports = __webpack_public_path__ + "img/look9.b90aacc0.png";